import React, {Component, ReactNode} from 'react';
import {Modal as MaterialModal, Card, Fade, Backdrop} from '@material-ui/core';
import './index.scss';
import {CloseIcon} from 'components/Icon';

interface ModalProps {
  className?: string;
  open: boolean;
  children?: ReactNode;
  onClosing?: ()=>void;
  onOpening?: ()=>void;
  closable?: boolean;
}

export default class Modal extends Component<ModalProps> {
  onCloseClick = () => {
    if(this.props.onClosing) {
      this.props.onClosing();
    }
  };

  componentWillReceiveProps(nextProps: Readonly<ModalProps>, nextContext: any): void {
    if(!this.props.open && nextProps.open) {
      if(this.props.onOpening) {
        this.props.onOpening();
      }
    }
  }

  render() {
    const closeable = this.props.closable !== false;
    return <MaterialModal open={this.props.open} closeAfterTransition={true} onClose={this.onCloseClick}
                          className={'modal ' + (this.props.className || '')} BackdropComponent={Backdrop}
                          disableBackdropClick={!closeable}>
      <Fade in={this.props.open}>
        <Card className="content">
          { closeable && <button className="close" onClick={this.onCloseClick}><CloseIcon/></button> }
          { this.props.children }
        </Card>
      </Fade>
    </MaterialModal>;
  }
}